<template>
  <div class="app-main-inner">
    <div class="form-card-wrapper">
      <el-form ref="basicForm" style="display: flex;" label-position="left" label-width="90px">
        <el-card class="form-card">
          <fieldset>
            <el-form-item :label="$t('SeaExport.JobNo')">
              <el-input v-model="job.jobNo" no="1" :disabled="viewStatus" />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.Mbl2')">
              <div style="display: flex">
                <el-input no="2" :value="job.mbl.substring(0,3)" :disabled="viewStatus" style="width:50px;" />
                <span style="padding-right: 1.5px;padding-left: 1.5px;">-</span>
                <el-input no="3" :value="job.mbl.substring(3)" :disabled="viewStatus" style="flex:1" />
                <el-button no="4" type="primary" :disabled="viewStatus" style="margin-left:1px;padding-left: 10px;padding-right: 10px;">{{ $t('SeaExport.PleaseSelect') }}</el-button>
              </div>
            </el-form-item>
            <el-form-item :label="$t('SeaExport.LoadingPort')">
              <div style="display: flex;justify-content: space-between">
                <el-input v-model="job.loadingPortCode" no="5" style="width: 60px;margin-right: 5px;" :disabled="viewStatus" />
                <cargo-advance-select
                  no="6"
                  filterable
                  :disabled="viewStatus"
                  :select-type="selectTypeNames.basic_data_Airport"
                  callback-method-type="value"
                  :default-value="job.loadingPortCode"
                  :callback-params="{key:'loadingPortCode'}"
                  style="flex: 1"
                  @parentCallBack="setJobSelectValue"
                />
              </div>
            </el-form-item>
            <el-form-item :label="$t('SeaExport.PortOfDestination')">
              <div style="display: flex;justify-content: space-between">
                <el-input v-model="job.destinationPortCode" no="7" style="width:60px;margin-right: 5px;" :disabled="viewStatus" />
                <cargo-advance-select
                  no="8"
                  filterable
                  :disabled="viewStatus"
                  :select-type="selectTypeNames.basic_data_Airport"
                  callback-method-type="value"
                  :default-value="job.destinationPortCode"
                  :callback-params="{key:'destinationPortCode'}"
                  style="flex: 1"
                  @parentCallBack="setJobSelectValue"
                />
              </div>
            </el-form-item>
            <el-form-item label="">
              <div style="display: flex;justify-content: space-between">
                <el-checkbox v-model="job.transfering" no="9" :disabled="viewStatus">{{ $t('SeaExport.Transit') }}</el-checkbox>
                <el-button no="10" :disabled="viewStatus" type="primary">{{ $t('SeaExport.EnterTransitInfo') }}</el-button>
              </div>
            </el-form-item>
            <el-form-item :label="$t('AirExport.CargoCollectionType')">
              <div style="display: flex;justify-content: space-between">
                <cargo-advance-select
                  no="11"
                  filterable
                  :disabled="viewStatus"
                  :select-type="selectTypeNames.local_cache_CargoSource"
                  callback-method-type="value"
                  :default-value="job.cargoSource"
                  :callback-params="{key:'cargoSource'}"
                  style="width: 98px"
                  @parentCallBack="setJobSelectValue"
                />
                <cargo-advance-select
                  no="12"
                  filterable
                  :disabled="viewStatus"
                  :select-type="selectTypeNames.basic_data_CutomJobType"
                  :method-params="{type:job.lob, active: true}"
                  callback-method-type="value"
                  :default-value="job.customJobType"
                  :callback-params="{key:'customJobType'}"
                  style="width: 98px"
                  @parentCallBack="setJobSelectValue"
                />
              </div>
            </el-form-item>
            <el-form-item :label="$t('SeaExport.DestinationAgent')">
              <cargo-advance-select
                no="13"
                :disabled="viewStatus"
                filterable
                :select-type="selectTypeNames.basic_data_Company"
                :method-params="{overseaAgent:true}"
                callback-method-type="value"
                :default-value="job.destinationAgent||''"
                tag-name="englishName"
                :callback-params="{key:'destinationAgent'}"
                @parentCallBack="setJobSelectValue"
              />
            </el-form-item>
            <el-form-item v-if="job.cargoSource === 'NC'" :label="$t('SeaExport.NominatedAgent')">
              <cargo-advance-select
                no="14"
                :disabled="viewStatus"
                filterable
                :select-type="selectTypeNames.basic_data_Company"
                :method-params="{overseaAgent:true}"
                callback-method-type="value"
                :default-value="job.designationAgent||''"
                tag-name="englishName"
                :callback-params="{key:'designationAgent'}"
                @parentCallBack="setJobSelectValue"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.BookingAgent')">
              <cargo-advance-select
                no="15"
                :disabled="viewStatus"
                filterable
                :select-type="selectTypeNames.basic_data_Company"
                :method-params="{bookingAgent:true}"
                callback-method-type="value"
                :default-value="job.bookingAgent||''"
                :callback-params="{key:'bookingAgent'}"
                @parentCallBack="setJobSelectValue"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.DocCutOffDate')">
              <el-date-picker
                v-model="job.fileCutoff"
                no="16"
                :disabled="viewStatus"
                type="date"
                style="width:100%;"
                clearable
                format="yyyy-MM-dd HH:mm"
                value-format="yyyy-MM-dd HH:mm"
              />
            </el-form-item>

            <!--todo SmartTextArea-->
            <el-form-item :label="$t('SeaExport.EnglishDescriptionOfGoods')">
              <el-input v-model="job.cargoEnglishName" no="17" :disabled="viewStatus" type="textarea" :rows="5" />
            </el-form-item>
          </fieldset></el-card>
        <el-card class="form-card">
          <fieldset>
            <div>
              <el-form-item label="" class="custom">
                <div style="display: flex;justify-content: space-between">
                  <div style="font-size: 12px;font-weight: normal;color: #404144">{{ $t('SeaExport.Quantity') }}</div>
                  <div style="font-size: 12px;font-weight: normal;color: #404144">{{ $t('SeaExport.Weight') }}KGS</div>
                  <div style="font-size: 12px;font-weight: normal;color: #404144">{{ $t('SeaExport.Cubage') }}CBM</div>
                  <div style="font-size: 12px;font-weight: normal;color: #404144">{{ $t('SeaExport.ChargedWeight') }}M/T</div>
                </div>
              </el-form-item>
              <el-form-item :label="$t('AirExport.Commission')" class="custom">
                <div style="display: flex;justify-content: space-between">
                  <el-input-number no="18" :value="job.quantityContract===0 ? undefined: job.quantityContract" :disabled="viewStatus" controls-position="right" />
                  <el-input-number no="19" :value="job.weightContract===0 ? undefined: job.weightContract" :disabled="viewStatus" controls-position="right" :precision="3" />
                  <el-input-number no="20" :value="job.cubageContract===0 ? undefined: job.cubageContract" :disabled="viewStatus" controls-position="right" :precision="3" />
                  <el-input-number no="21" :value="job.chargeWeight===0 ? undefined: job.chargeWeight" :disabled="viewStatus" controls-position="right" :precision="3" />
                </div>
              </el-form-item>
              <el-form-item :label="$t('SeaExport.Booking')" class="custom">
                <div style="display: flex;justify-content: space-between">
                  <el-input-number no="22" :value="job.quantityBooking===0 ? undefined: job.quantityBooking" :disabled="viewStatus" controls-position="right" />
                  <el-input-number no="23" :value="job.weightBooking===0 ? undefined: job.weightBooking" :disabled="viewStatus" controls-position="right" :precision="3" />
                  <el-input-number no="24" :value="job.cubageBooking===0 ? undefined: job.cubageBooking" :disabled="viewStatus" controls-position="right" :precision="3" />
                  <el-input-number no="25" :value="job.chargeWeightBooking===0 ? undefined: job.chargeWeightBooking" :disabled="viewStatus" controls-position="right" :precision="3" />
                </div>
              </el-form-item>
              <el-form-item :label="$t('SeaExport.Actual')" class="custom">
                <div style="display: flex;justify-content: space-between">
                  <el-input-number no="26" :value="job.quantityActual===0 ? undefined: job.quantityActual" :disabled="viewStatus" controls-position="right" />
                  <el-input-number no="27" :value="job.weightActual===0 ? undefined: job.weightActual" :disabled="viewStatus" controls-position="right" :precision="3" />
                  <el-input-number no="28" :value="job.cubageActual===0 ? undefined: job.cubageActual" :disabled="viewStatus" controls-position="right" :precision="3" />
                  <el-input-number no="29" :value="job.cWeight===0 ? undefined: job.cWeight" :disabled="viewStatus" controls-position="right" :precision="1" />
                </div>
              </el-form-item>
              <!-- todo cargoDoc-->
              <el-form-item :label="$t('SeaExport.Documentation')" class="custom">
                <div style="display: flex;justify-content: space-between">
                  <el-input-number no="30" :value="cargoDoc.quantity===0 ? undefined: cargoDoc.quantity" :disabled="viewStatus" controls-position="right" />
                  <el-input-number no="31" :value="cargoDoc.weight===0 ? undefined: cargoDoc.weight" :disabled="viewStatus" controls-position="right" :precision="3" />
                  <el-input-number no="32" :value="cargoDoc.cubage===0 ? undefined: cargoDoc.cubage" :disabled="viewStatus" controls-position="right" :precision="3" />
                  <el-input-number no="33" :value="cWeight==0 ? undefined: cWeight" :disabled="viewStatus" controls-position="right" :precision="1" />
                </div>
              </el-form-item>
            </div>
            <div style="display: flex;">
              <div style="margin-right: 20px;flex-grow: 1">
                <el-form-item :label="$t('SeaExport.AirlineCompany')">
                  <cargo-advance-select
                    no="34"
                    :disabled="viewStatus"
                    filterable
                    :select-type="selectTypeNames.basic_data_Company"
                    :method-params="{airCmp:true}"
                    callback-method-type="value"
                    :default-value="job.carrierId||''"
                    :callback-params="{key:'carrierId'}"
                    @parentCallBack="setJobSelectValue"
                  />
                </el-form-item>
                <el-form-item :label="$t('SeaExport.Flight')">
                  <el-input v-model="job.voyageFlight" no="35" :disabled="viewStatus" />
                </el-form-item>
                <el-form-item :label="$t('SeaExport.OperationDate')">
                  <el-date-picker
                    v-model="job.customsDate"
                    no="36"
                    :disabled="viewStatus"
                    type="date"
                    clearable
                  />
                </el-form-item>
                <el-form-item :label="$t('SeaExport.DateOfDeparture')">
                  <el-date-picker
                    v-model="job.etd"
                    no="37"
                    :disabled="viewStatus"
                    type="date"
                    clearable
                  />
                </el-form-item>
                <el-form-item :label="$t('SeaExport.DateOfArrival')">
                  <el-date-picker
                    v-model="job.ETA"
                    no="38"
                    :disabled="viewStatus"
                    type="date"
                    clearable
                  />
                </el-form-item>
                <el-form-item :label="$t('SeaExport.Marks')">
                  <el-input v-model="job.mark" no="39" :disabled="viewStatus" type="textarea" :rows="5" />
                </el-form-item>
              </div>
              <div style="flex-grow: 1">
                <el-form-item :label="$t('SeaExport.MasterBLFreightTerm')">
                  <cargo-advance-select
                    no="40"
                    filterable
                    :disabled="viewStatus"
                    :select-type="selectTypeNames.basic_data_PaymentTerm"
                    callback-method-type="value"
                    :default-value="job.paymentTermMBL"
                    :callback-params="{key:'paymentTermMBL'}"
                    @parentCallBack="setJobSelectValue"
                  />
                </el-form-item>
                <el-form-item :label="$t('SeaExport.BookingProperty')">
                  <cargo-advance-select
                    no="41"
                    filterable
                    :disabled="viewStatus"
                    :select-type="selectTypeNames.local_cache_BookingTerm"
                    callback-method-type="value"
                    :default-value="job.bookingTerm"
                    :callback-params="{key:'bookingTerm'}"
                    @parentCallBack="setJobSelectValue"
                  />
                </el-form-item>
                <el-form-item :label="$t('SeaExport.CargoType')">
                  <cargo-advance-select
                    no="42"
                    filterable
                    :disabled="viewStatus"
                    :select-type="selectTypeNames.basic_data_CargoType"
                    callback-method-type="value"
                    :default-value="job.cargoType"
                    :callback-params="{key:'cargoType'}"
                    @parentCallBack="setJobSelectValue"
                  />
                </el-form-item>
                <el-form-item :label="$t('SeaExport.Package')">
                  <!-- <cargo-advance-select
                    filterable
                    :disabled="viewStatus"
                    :select-type="selectTypeNames.basic_data_Packing"
                    callback-method-type="value"
                    :default-value="job.packing"
                    tag-name="chineseName"
                    :callback-params="{key:'packing'}"
                    @parentCallBack="setJobSelectValue"
                  /> -->
                  <cargo-packing-select
                    no="43"
                    :default-value="job.packing"
                    :callback-params="{}"
                    @change="p => {p.key = 'packing';setJobSelectValue(p)}"
                  />
                </el-form-item>
                <el-form-item :label="$t('SeaExport.AdditionalNotes')">
                  <el-input v-model="job.remarks" no="44" :disabled="viewStatus" type="textarea" :rows="5" />
                </el-form-item>
              </div>
            </div>
          </fieldset></el-card>
        <el-card class="form-card">
          <fieldset>
            <el-form-item :label="$t('SeaExport.TradeMethod')">
              <cargo-advance-select
                no="45"
                filterable
                :disabled="viewStatus"
                :select-type="selectTypeNames.basic_data_TradeTerm"
                callback-method-type="value"
                :default-value="job.tradeTerm"
                :callback-params="{key:'tradeTerm'}"
                @parentCallBack="setJobSelectValue"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.Documents')">
              <cargo-advance-select
                no="46"
                filterable
                :disabled="viewStatus"
                :select-type="selectTypeNames.basic_data_User"
                callback-method-type="value"
                :default-value="job.dc==0?'':job.dc"
                :callback-params="{key:'dc'}"
                @parentCallBack="setJobSelectValue"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.AirlinePerson2')">
              <cargo-advance-select
                no="47"
                filterable
                :disabled="viewStatus"
                :select-type="selectTypeNames.basic_data_User"
                callback-method-type="value"
                :default-value="job.planner==0?'':job.planner"
                :callback-params="{key:'planner'}"
                @parentCallBack="setJobSelectValue"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.FieldOperation')">
              <cargo-advance-select
                no="48"
                filterable
                :disabled="viewStatus"
                :select-type="selectTypeNames.basic_data_User"
                callback-method-type="value"
                :default-value="job.siteOP==0?'':job.siteOP"
                :callback-params="{key:'siteOP'}"
                @parentCallBack="setJobSelectValue"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.SalesOfGoods')">
              <cargo-advance-select
                no="49"
                filterable
                :disabled="viewStatus"
                :select-type="selectTypeNames.basic_data_User"
                callback-method-type="value"
                :default-value="job.cargoSalesId==0?'':job.cargoSalesId"
                :callback-params="{key:'cargoSalesId'}"
                @parentCallBack="setJobSelectValue"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.OperationCompany')">
              <cargo-advance-select
                no="50"
                :disabled="viewStatus"
                :select-type="selectTypeNames.basic_data_Office"
                filterable
                :callback-params="{key:'opOffice'}"
                callback-method-type="value"
                :default-value="job.opOffice"
                @parentCallBack="setJobSelectValue"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.OperationDepartment')">
              <cargo-department-select
                no="51"
                :disabled="viewStatus"
                :office-id="Number(job.opOffice)"
                :department-id="Number(job.opDepartment)"

                @change="p=>{job.opDepartment=p.value}"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.Operation')">
              <cargo-advance-select
                no="52"
                filterable
                :disabled="viewStatus"
                :select-type="selectTypeNames.basic_data_User"
                callback-method-type="value"
                :default-value="job.op==0?'':job.op"
                :callback-params="{key:'op'}"
                @parentCallBack="setJobSelectValue"
              />
            </el-form-item>
            <el-form-item :label="$t('Payment.customerService')">
              <cargo-advance-select
                no="53"
                filterable
                :disabled="viewStatus"
                :select-type="selectTypeNames.basic_data_User"
                callback-method-type="value"
                :default-value="job.csr==0?'':job.csr"

                :callback-params="{key:'csr'}"
                @parentCallBack="setJobSelectValue"
              />
            </el-form-item>
            <el-form-item v-show="isAddUserDefinedRoles" :label="$t('CargoMsg.Cargo_userDefinedRole1')">
              <cargo-user-select
                ref="userDefinedRoleId1"
                no="userDefinedRoleId1"
                :disabled="viewStatus"
                :method-params="{officeId:$store.getters.currentOfficeId,category:'role',shape:'userDefinedRole1'}"
                :default-value="job.userDefinedRoleId1||''"
                :merge-load="true"
                @change="p=>{pm.userDefinedRoleId1Handler(p)}"
              />
            </el-form-item>
            <el-form-item v-show="isAddUserDefinedRoles" :label="$t('CargoMsg.Cargo_userDefinedRole2')">
              <cargo-user-select
                ref="userDefinedRoleId2"
                no="userDefinedRoleId2"
                :disabled="viewStatus"
                :method-params="{officeId:$store.getters.currentOfficeId,category:'role',shape:'userDefinedRole2'}"
                :default-value="job.userDefinedRoleId2||''"
                :merge-load="true"
                @change="p=>{pm.userDefinedRoleId2Handler(p)}"
              />
            </el-form-item>
          </fieldset></el-card>
        <el-card class="form-card">
          <fieldset>
            <el-form-item :label="$t('SeaExport.UserDefinedField1')">
              <el-input v-model="job.userDefinedField1" no="54" :disabled="viewStatus" type="textarea" :rows="5" />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.UserDefinedField2')">
              <el-input v-model="job.userDefinedField2" no="55" :disabled="viewStatus" type="textarea" :rows="5" />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.UserDefinedField3')">
              <el-input v-model="job.userDefinedField3" no="56" :disabled="viewStatus" type="textarea" :rows="5" />
            </el-form-item>
          </fieldset></el-card>

      </el-form>
    </div>
    <div class="form-card-wrapper" style="flex-direction: row;width: 100%">
      <el-card class="form-card" style="flex:1">
        <fieldset>
          <legend>{{ $t('SeaExport.TicketsInfo') }}</legend>
          <div style="display:flex;justify-content: flex-end">
            <div class="triggers" style="margin-bottom: 5px;">
              <span>{{ $t('SeaExport.TotalTickets') }}:</span><span style="margin-right: 5px;">{{ job.lclSlaves.length || 0 }}</span>
              <el-button no="57" type="primary" :disabled="viewStatus || viewSource === 'financeDetail' || viewSource === 'salesDetail'">{{ $t('SeaExport.NewTickets') }}</el-button>
              <el-button no="58" type="primary" :disabled="viewStatus || viewSource === 'financeDetail' || viewSource === 'salesDetail'">{{ $t('SeaExport.EditTickets') }}</el-button>
              <el-button no="59" type="primary" :disabled="viewStatus || viewSource === 'financeDetail' || viewSource === 'salesDetail'">{{ $t('SeaExport.AddTickets') }}</el-button>
              <el-button no="60" type="danger" :disabled="viewStatus || viewSource === 'financeDetail' || viewSource === 'salesDetail'">{{ $t('SeaExport.RemoveTickets') }}</el-button>
            </div>
          </div>
          <div style="min-height: 200px;flex-direction: column">
            <cargo-ag-grid
              config-module="150007"
              :grid-options="gridOptions"
              :column-defs="columnDefs"
              :row-data="job.lclSlaves||[]"
              style="height:300px;width: 100%"
              @gridReady="params=>{gridApi=params.api}"
            />
          </div>
        </fieldset>
      </el-card>
    </div>
  </div>
</template>

<script>
import cargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import cargoPackingSelect from '@/components/Cargo/Common/cargoPackingSelect'

import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import { cacheName, cache } from '@/utils/cacheManager'
import { MasterBasicTabHP } from './masterBasicTabHP'
import { AirExportJob } from '@/class/model/booking/AirExportJob'
import ColumnUtils from '@/utils/ColumnUtils'
import { formatNumberToThousands } from '@/utils'
import cargoDepartmentSelect from '@/components/Cargo/Common/cargoDepartmentSelect'

export default {
  name: 'MasterBasicTab',
  components: { cargoAdvanceSelect, cargoPackingSelect, cargoDepartmentSelect },
  props: {
    context: {
      type: Object,
      required: true
    },
    action: {
      type: String,
      required: true
    },
    viewSource: {
      type: String,
      required: false
    },
    cooperateEdit: { // 能否修改
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      pm: new MasterBasicTabHP(this),
      selectTypeNames: TYPE_NAMES,
      loading: false,
      gridOptions: {},
      gridParams: {},
      gridApi: {},
      columnDefs: null,
      sideBarDefs: { toolPanels: ['columns', 'filter'], visible: false },
      rowData: [],
      optStatusDefs: {
        edit: 'edit', // edit
        view: 'view' // 查看
      },
      job: new AirExportJob().fillDefaultValue().getData(),
      currentOptStatus: 'view',
      officeList: [],
      config: {},
      cargoDoc: {},
      cWeight: 0,
      isAddUserDefinedRoles: false // 是否显示自定义岗位
    }
  },
  computed: {
    viewStatus() {
      if (!this.cooperateEdit) return true
      return this.action === 'look'
    },
    editStatus() {
      return this.optStatusDefs.edit === this.currentOptStatus
    }
  },
  watch: {
  },
  async created() {
    await this.prepareData()
    this.columnDefs = [
      {
        headerName: '', width: 55, checkboxSelection: true,
        sortable: false, suppressMenu: true, suppressSizeToFit: true, resizable: false,
        headerCheckboxSelection: true
      },
      {
        headerName: this.$t('SeaExport.JobNo'),
        field: 'jobNo',
        width: 200
      },
      {
        headerName: 'HAWB',
        field: 'hblNbr2',
        width: 120

      },
      {
        headerName: this.$t('SeaExport.LoadingPort'),
        field: 'loadingPortCode',
        width: 120,
        cellRenderer: (params) => {
          return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Airport, 'code', params.value, 'englishName')
        }
      },
      {
        headerName: this.$t('SeaExport.PortOfDestination'),
        field: 'destinationPortCode',
        width: 120,
        cellRenderer: (params) => {
          return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Airport, 'code', params.value, 'englishName')
        }
      },
      {
        headerName: this.$t('SeaExport.DateOfDeparture'),
        field: 'etd',
        width: 120,
        cellRenderer: (params) => {
          return ColumnUtils.dateLabelFunc(params.value)
        }
      },
      {
        headerName: this.$t('SeaExport.CommissionedNumberOfPackages'),
        field: 'quantityContract',
        width: 120,
        cellRenderer: (params) => {
          return !params.value ? 0 : formatNumberToThousands(ColumnUtils.number2ColumnLabelFunc(params.value))
        }
      },
      {
        headerName: this.$t('SeaExport.CommissionedGrossWeight'),
        field: 'weightContract',
        width: 120,
        cellRenderer: (params) => {
          return formatNumberToThousands(ColumnUtils.number3ColumnLabelFunc(params.value))
        }
      },
      {
        headerName: this.$t('SeaExport.CommissionedVolume'),
        field: 'cubageContract',
        width: 120,
        cellRenderer: (params) => {
          return formatNumberToThousands(ColumnUtils.number3ColumnLabelFunc(params.value))
        }
      },
      {
        headerName: this.$t('SeaExport.CommissionedChargedWeight'),
        field: 'chargeWeight',
        width: 150,
        cellRenderer: (params) => {
          return formatNumberToThousands(ColumnUtils.number3ColumnLabelFunc(params.value))
        }
      },
      {
        headerName: this.$t('SeaExport.ActualQuantity'),
        field: 'quantityActual',
        width: 120,
        cellRenderer: (params) => {
          return !params.value ? 0 : formatNumberToThousands(ColumnUtils.number2ColumnLabelFunc(params.value))
        }
      },
      {
        headerName: this.$t('SeaExport.ActualWeight'),
        field: 'weightActual',
        width: 120,
        cellRenderer: (params) => {
          return formatNumberToThousands(ColumnUtils.number3ColumnLabelFunc(params.value))
        }
      },
      {
        headerName: this.$t('SeaExport.ActualVolume'),
        field: 'cubageActual',
        width: 120,
        cellRenderer: (params) => {
          return formatNumberToThousands(ColumnUtils.number3ColumnLabelFunc(params.value))
        }
      },
      {
        headerName: this.$t('SeaExport.ActualChargedWeight'),
        field: 'cWeight',
        width: 150,
        cellRenderer: (params) => {
          return formatNumberToThousands(ColumnUtils.numberColumnLabelFunc(params.value, 3))
        }
      }, {
        headerName: this.$t('CargoMsg.Cargo_Shipper'),
        colId: 'shipperLine1',
        field: 'shipperLine1',
        hide: true,
        width: 120
      }, {
        headerName: this.$t('CargoMsg.Cargo_Consignee'),
        colId: 'consigneeLine1',
        field: 'consigneeLine1',
        hide: true,
        width: 120
      }
    ]
  },
  beforeMount() {
  },
  methods: {
    setJobSelectValue(obj) {
      this.job[obj.key] = obj.value
    },
    async onShow(row, isRefresh) {
      if (!isRefresh) {
        return
      }
      // todo created 未加载完成导致config 未获取到
      await this.prepareData()

      if (row.uuid) {
        const job = new AirExportJob(row)
        this.job = job
        this.pm.updateView()

        if (this.job.cargoDoc && this.job.cargoDoc.length > 0) {
          this.cargoDoc = this.job.cargoDoc[0]
          const airCargoDoc = this.job.airCargoDoc.find(item => item.uuid === this.cargoDoc.uuid)
          if (airCargoDoc) {
            this.cWeight = airCargoDoc.cWeight
          }
        }
      }
    },
    /**
     * 准备好数据
     */
    async prepareData() {
      this.loading = true
      await cache.load(cacheName.OFFICE_LIST, cacheName.CONFIG)
      this.officeList = cache.officeList
      this.config = cache.config
      this.loading = false
      this.isAddUserDefinedRoles = Number(this.config.get('IsAddUserDefinedRoles')) === 1
    }
  }
}
</script>

<style scoped lang="scss">
  .el-form-item-group fieldset{
    min-height: 500px;
    width: 350px;
  }
</style>
